import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-5 h-100 overflow-y-scroll text-start" }
const _hoisted_2 = { class: "form-floating mb-3" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "form-floating mb-3" }
const _hoisted_5 = ["value", "onscroll"]
const _hoisted_6 = {
  class: "d-flex w-100 mb-3",
  role: "group",
  "aria-label": "Basic radio toggle button group"
}
const _hoisted_7 = { class: "form-floating flex-fill me-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-floating flex-fill me-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "w-25 form-floating" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "d-flex w-100" }
const _hoisted_15 = { class: "form-floating flex-fill me-2" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-floating flex-fill" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-floating mb-3" }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "d-flex w-100"
}
const _hoisted_22 = { class: "form-floating flex-fill me-2" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "form-floating flex-fill" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "d-flex w-100 mb-3" }
const _hoisted_27 = { class: "form-floating flex-fill me-2" }
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-floating w-38" }
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 1,
  class: "d-flex w-100"
}
const _hoisted_33 = { class: "form-floating flex-fill me-2" }
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "w-25 form-floating" }
const _hoisted_37 = ["value"]
const _hoisted_38 = {
  key: 2,
  class: "form-floating flex-fill"
}
const _hoisted_39 = { class: "d-flex w-100 mb-3" }
const _hoisted_40 = { class: "form-floating flex-fill me-2" }
const _hoisted_41 = ["value"]
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "form-floating w-38" }
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 3,
  class: "d-flex w-100"
}
const _hoisted_46 = { class: "form-floating flex-fill me-2" }
const _hoisted_47 = ["value"]
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "w-25 form-floating" }
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 4,
  class: "form-floating flex-fill"
}
const _hoisted_52 = { class: "d-flex w-100 mt-3" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "text",
        class: "form-control",
        placeholder: "Nombre del evento",
        onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
        value: _ctx.currentData.name || _ctx.eventData.name,
        name: "name",
        autocomplete: "false"
      }, null, 40, _hoisted_3),
      _cache[20] || (_cache[20] = _createElementVNode("label", null, "Nombre", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("textarea", {
        class: "form-control",
        placeholder: "Detalles del evento",
        onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
        value: _ctx.currentData.description || _ctx.eventData.description,
        name: "description",
        onscroll: _ctx.scrolled,
        style: {"height":"150px"}
      }, null, 40, _hoisted_5),
      _createElementVNode("label", {
        class: "floatingTextarea",
        style: _normalizeStyle(`opacity: ${_ctx.textareaOpacity};`)
      }, "Detalles del ticket", 4)
    ]),
    _cache[43] || (_cache[43] = _createElementVNode("h5", null, "Paquéte de tickets", -1)),
    _cache[44] || (_cache[44] = _createElementVNode("p", null, "¿Esta opción es un paquéte de tickets?", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("select", {
          class: "form-control",
          name: "is_pack",
          value: _ctx.is_pack,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          autocomplete: "false"
        }, [...(_cache[21] || (_cache[21] = [
          _createElementVNode("option", { value: "is_pack" }, "Sí", -1),
          _createElementVNode("option", { value: "is_not_pack" }, "No", -1)
        ]))], 40, _hoisted_8),
        _cache[22] || (_cache[22] = _createElementVNode("label", null, "¿Es un paquete?", -1))
      ]),
      (_ctx.is_pack == 'is_pack')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("select", {
                class: "form-control",
                name: "pack_option",
                value: _ctx.currentData.pack_option || _ctx.eventData.pack_option,
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                autocomplete: "false"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allOptions, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.id,
                    key: option.id
                  }, _toDisplayString(option.name), 9, _hoisted_11))
                }), 128))
              ], 40, _hoisted_10),
              _cache[23] || (_cache[23] = _createElementVNode("label", null, "Tipo de boleto", -1))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Teléfono",
                autocomplete: "false",
                min: "0",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
                value: _ctx.currentData.pack_quantity || _ctx.eventData.pack_quantity,
                name: "pack_quantity"
              }, null, 40, _hoisted_13),
              _cache[24] || (_cache[24] = _createElementVNode("label", null, "Cantidad", -1))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _cache[45] || (_cache[45] = _createElementVNode("h5", null, "Tickets por orden", -1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("input", {
          type: "number",
          class: "form-control",
          placeholder: "Teléfono",
          autocomplete: "false",
          min: "0",
          onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          value: 
            _ctx.currentData.tickets_per_order_minimum_quantity ||
            _ctx.eventData.tickets_per_order_minimum_quantity ||
            0
          ,
          name: "tickets_per_order_minimum_quantity"
        }, null, 40, _hoisted_16),
        _cache[25] || (_cache[25] = _createElementVNode("label", null, "Mínimo", -1))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("input", {
          type: "number",
          class: "form-control",
          autocomplete: "false",
          onKeyup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          min: "0",
          value: 
            _ctx.currentData.tickets_per_order_maximum_quantity ||
            _ctx.eventData.tickets_per_order_maximum_quantity ||
            0
          ,
          name: "tickets_per_order_maximum_quantity"
        }, null, 40, _hoisted_18),
        _cache[26] || (_cache[26] = _createElementVNode("label", null, "Máximo", -1))
      ])
    ]),
    _cache[46] || (_cache[46] = _createElementVNode("h5", null, "Precio", -1)),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("select", {
        class: "form-control",
        name: "type",
        value: _ctx.currentData.type || _ctx.eventData.type,
        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
        autocomplete: "false"
      }, [...(_cache[27] || (_cache[27] = [
        _createElementVNode("option", { value: "paid" }, "Pagado", -1),
        _createElementVNode("option", { value: "free" }, "Gratuito", -1)
      ]))], 40, _hoisted_20),
      _cache[28] || (_cache[28] = _createElementVNode("label", null, "Tipo de boleto", -1))
    ]),
    ((_ctx.currentData.type || _ctx.eventData.type) == 'paid')
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("input", {
              type: "number",
              class: "form-control",
              placeholder: "Teléfono",
              autocomplete: "false",
              min: "0",
              onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
              value: _ctx.currentData.price_value || _ctx.eventData.price_value || 0,
              name: "price_value"
            }, null, 40, _hoisted_23),
            _createElementVNode("label", null, [
              _cache[29] || (_cache[29] = _createTextVNode("Precio", -1)),
              (_ctx.event?.currency)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" (" + _toDisplayString(_ctx.event?.currency) + ")", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("input", {
              type: "number",
              class: "form-control",
              autocomplete: "false",
              min: "0",
              onKeyup: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
              value: 
            _ctx.currentData.available_quantity || _ctx.eventData.available_quantity || 0
          ,
              name: "available_quantity"
            }, null, 40, _hoisted_25),
            _cache[30] || (_cache[30] = _createElementVNode("label", null, "Cantidad de boletos disponibles", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[47] || (_cache[47] = _createElementVNode("h5", null, "Inicio de venta de boletos", -1)),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("select", {
          class: "form-control",
          name: "ticket_sales_starts_type",
          value: 
            _ctx.currentData.ticket_sales_starts_type ||
            _ctx.eventData.ticket_sales_starts_type
          ,
          onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          autocomplete: "false"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.ticketSales), (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              value: opt[0],
              key: opt[0]
            }, _toDisplayString(opt[1]), 9, _hoisted_29))
          }), 128))
        ], 40, _hoisted_28),
        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Comenzar a vender", -1))
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("select", {
          class: "form-control",
          name: "ticket_sales_starts_hide",
          value: 
            _ctx.currentData.ticket_sales_starts_hide ||
            _ctx.eventData.ticket_sales_starts_hide
          ,
          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          autocomplete: "false"
        }, [...(_cache[32] || (_cache[32] = [
          _createElementVNode("option", { value: "true" }, "Sí", -1),
          _createElementVNode("option", { value: "false" }, "No", -1)
        ]))], 40, _hoisted_31),
        _cache[33] || (_cache[33] = _createElementVNode("label", null, "Ocultar antes de iniciar venta", -1))
      ])
    ]),
    (
        (_ctx.currentData.ticket_sales_starts_type ||
          _ctx.eventData.ticket_sales_starts_type) != 'immediately' &&
        (_ctx.currentData.ticket_sales_starts_type ||
          _ctx.eventData.ticket_sales_starts_type) != 'never' &&
        (_ctx.currentData.ticket_sales_starts_type ||
          _ctx.eventData.ticket_sales_starts_type) != 'fix_date'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("select", {
              class: "form-control",
              name: "ticket_sales_starts_unit",
              value: 
            _ctx.currentData.ticket_sales_starts_unit ||
            _ctx.eventData.ticket_sales_starts_unit
          ,
              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.units), (unit) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: unit[0],
                  value: unit[0]
                }, _toDisplayString(unit[1]), 9, _hoisted_35))
              }), 128))
            ], 40, _hoisted_34),
            _cache[34] || (_cache[34] = _createElementVNode("label", null, "Unidad de tiempo", -1))
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("input", {
              type: "number",
              class: "form-control",
              placeholder: "Teléfono",
              autocomplete: "false",
              min: "0",
              onKeyup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
              value: 
            _ctx.currentData.ticket_sales_starts_value ||
            _ctx.eventData.ticket_sales_starts_value ||
            0
          ,
              name: "ticket_sales_starts_value"
            }, null, 40, _hoisted_37),
            _cache[35] || (_cache[35] = _createElementVNode("label", null, "Valor", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (
        (_ctx.currentData.ticket_sales_starts_type ||
          _ctx.eventData.ticket_sales_starts_type) == 'fix_date'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createVNode(_component_VueDatePicker, {
            "onUpdate:modelValue": _ctx.modifyDateEnd,
            "model-value": _ctx.ticketSalesEndsValue,
            name: "ticket_sales_starts_value",
            vertical: "",
            "enable-time-picker": true,
            "auto-apply": "",
            "is-24": false,
            "time-picker-inline": "",
            class: "form-control p-0",
            "min-date": new Date(),
            format: _ctx.formatDate
          }, null, 8, ["onUpdate:modelValue", "model-value", "min-date", "format"]),
          _cache[36] || (_cache[36] = _createElementVNode("label", null, "Fecha y hora de inicio", -1))
        ]))
      : _createCommentVNode("", true),
    _cache[48] || (_cache[48] = _createElementVNode("h5", null, "Final de venta de boletos", -1)),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("select", {
          class: "form-control",
          name: "ticket_sales_ends_type",
          value: 
            _ctx.currentData.ticket_sales_ends_type ||
            _ctx.eventData.ticket_sales_ends_type
          ,
          onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          autocomplete: "false"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.ticketSales), (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              value: opt[0],
              key: opt[0]
            }, _toDisplayString(opt[1]), 9, _hoisted_42))
          }), 128))
        ], 40, _hoisted_41),
        _cache[37] || (_cache[37] = _createElementVNode("label", null, "Dejar a vender", -1))
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("select", {
          class: "form-control",
          name: "ticket_sales_ends_hide",
          value: 
            _ctx.currentData.ticket_sales_ends_hide ||
            _ctx.eventData.ticket_sales_ends_hide
          ,
          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
          autocomplete: "false"
        }, [...(_cache[38] || (_cache[38] = [
          _createElementVNode("option", { value: "true" }, "Sí", -1),
          _createElementVNode("option", { value: "false" }, "No", -1)
        ]))], 40, _hoisted_44),
        _cache[39] || (_cache[39] = _createElementVNode("label", null, "Ocultar al finalizar venta", -1))
      ])
    ]),
    (
        (_ctx.currentData.ticket_sales_ends_type ||
          _ctx.eventData.ticket_sales_ends_type) != 'immediately' &&
        (_ctx.currentData.ticket_sales_ends_type ||
          _ctx.eventData.ticket_sales_ends_type) != 'never' &&
        (_ctx.currentData.ticket_sales_ends_type ||
          _ctx.eventData.ticket_sales_ends_type) != 'fix_date'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("select", {
              class: "form-control",
              name: "ticket_sales_ends_unit",
              value: 
            _ctx.currentData.ticket_sales_ends_unit ||
            _ctx.eventData.ticket_sales_ends_unit
          ,
              onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.units), (unit) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: unit[0],
                  value: unit[0]
                }, _toDisplayString(unit[1]), 9, _hoisted_48))
              }), 128))
            ], 40, _hoisted_47),
            _cache[40] || (_cache[40] = _createElementVNode("label", null, "Unidad de tiempo", -1))
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("input", {
              type: "number",
              class: "form-control",
              placeholder: "Teléfono",
              autocomplete: "false",
              min: "0",
              onKeyup: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.modifyValue && _ctx.modifyValue(...args))),
              value: 
            _ctx.currentData.ticket_sales_ends_value ||
            _ctx.eventData.ticket_sales_ends_value ||
            0
          ,
              name: "ticket_sales_ends_value"
            }, null, 40, _hoisted_50),
            _cache[41] || (_cache[41] = _createElementVNode("label", null, "Valor", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (
        (_ctx.currentData.ticket_sales_ends_type ||
          _ctx.eventData.ticket_sales_ends_type) == 'fix_date'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createVNode(_component_VueDatePicker, {
            "onUpdate:modelValue": _ctx.modifyDateEnd,
            "model-value": _ctx.ticketSalesEndsValue,
            name: "ticket_sales_ends_value",
            vertical: "",
            "enable-time-picker": true,
            "auto-apply": "",
            "is-24": false,
            "time-picker-inline": "",
            class: "form-control p-0",
            "min-date": new Date(),
            format: _ctx.formatDate
          }, null, 8, ["onUpdate:modelValue", "model-value", "min-date", "format"]),
          _cache[42] || (_cache[42] = _createElementVNode("label", null, "Fecha y hora de final", -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("button", {
        class: "btn btn-secondary ms-auto",
        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args))),
        disabled: !_ctx.editing
      }, "Reestablecer", 8, _hoisted_53),
      _createElementVNode("button", {
        class: "btn btn-primary ms-2",
        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.saveData && _ctx.saveData(...args))),
        disabled: !_ctx.editing
      }, "Guardar cambios", 8, _hoisted_54)
    ])
  ]))
}